import React from 'react'
import styled from 'styled-components'
import { Column, Row } from 'components/common/layout'
import { Black3Text, ExplainText } from 'components/scouts/common/styles'
import { Slider } from 'components/common/slider'
import { FiMinus } from 'react-icons/fi'
import { theme } from 'infra/theme'
import { BaseText } from 'components/common/text'

export const RangeSlider: React.FC<{
  title: string
  value: number[]
  min: number
  max: number
  onChange: (v: number[]) => void
  unit?: string
  maxUnit?: string
  step?: number
  width?: number
}> = ({ title, value, min, max, onChange, unit, maxUnit, step, width }) => {
  return (
    <RangeContainer width={width}>
      <Row style={{ justifyContent: 'space-between' }}>
        <ExplainText>{title}</ExplainText>
        <Row style={{ gap: 8 }}>
          {value[0] !== value[1] && (
            <>
              <RangeNumberBox>
                <Black3Text>{`${value[0]}${unit ? unit : ''}`}</Black3Text>
              </RangeNumberBox>
              <FiMinus size={8} strokeWidth={4} color={theme.color.black3} />{' '}
            </>
          )}
          <RangeNumberBox>
            <Black3Text>{`${
              maxUnit && value[1] === max
                ? maxUnit
                : `${value[1]}${unit ? unit : ''}`
            }${value[1] === max ? ' 이상' : ''}`}</Black3Text>
          </RangeNumberBox>
        </Row>
      </Row>
      <Slider
        min={min}
        max={max}
        value={value}
        onChange={(_v) => {
          const v = _v as number[]
          onChange(v)
        }}
        step={step}
      />
    </RangeContainer>
  )
}

const RangeContainer = styled(Column)<{ width?: number }>`
  gap: 40px;
  width: ${(p) => (p.width ? p.width : 650)}px;
  justify-content: end;

  @media ${(p) => p.theme.deviceSize.mobile} {
    width: 100%;
  }
`

export const RangeNumberBox = styled(BaseText)`
  width: fit-content;
  white-space: nowrap;
  padding: 6px 12px;
  border-radius: 8px;
  background-color: ${(p) => p.theme.color.white1};
  box-shadow: 0px 2px 4px 0px #00000030 inset;
  color: ${(p) => p.theme.color.black3};
`
